import * as React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import MenuIcon from '@mui/icons-material/Menu';
import Link from '@mui/material/Link';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

import Copyright from './components/Copyright';
import { AppBar, Drawer } from './components/AppBar';
import NFTOverview from './components/NFTOverview';
import NFTreesGallery from './components/NFTreesGallery';
import UserOverview from './components/UserOverview';
import MapOverview from './components/MapOverview';
import CallToActionModal from './components/CallToActionModal';

import { ethers } from 'ethers';
import TimelineComponent from './components/Timeline';

const eth_provider = new ethers.providers.JsonRpcProvider('https://rpc.ankr.com/eth');

const default_address = '0x2dBC5A4A615c9fa0f93207467ad9fc277FaEF479';

const mdTheme = createTheme({
  palette: {
      primary: {
        main: '#004D40',
      },
      secondary: {
        main: '#DCDCDC'
      },
      info: {
        main: '#6D4C41'
      }
  }
});

function getNFTrees(collections) {
  const nftrees: any = [];
  collections.forEach((col) => {
      if (col.is_nftree) {
          col.ids.forEach((nftree) => {
              nftrees.push(nftree);
          })
      }
  });
  return nftrees
}

function hasNFTrees(collections){
  var has_nftrees = false;
  collections.forEach((col) => {
      if (col.is_nftree) {
        if (col.ids.length > 0) {
          has_nftrees = true;
        }
      }
  });
  return has_nftrees
}

function hasMemberCard(collections) {
  var has_mc = "no";
  collections.forEach((col) => {
    if (col.name === "BloomeriaMemberCard") {
        has_mc = "yes";
    }
  });
  return has_mc
}

class DashboardContent extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      openMenu: false,
      user_address: default_address,
      user_ens: null,
      user_input: null,
      previous_address: default_address,
      error: null,
      isLoaded: false,
      items: [],
      nftrees: [],
      openCallToActionModal: false
    };

    this.setOpen = this.setOpen.bind(this);
    this.toggleDrawer = this.toggleDrawer.bind(this);
    this.setUserInput = this.setUserInput.bind(this);
    this.setOpenCallToAction = this.setOpenCallToAction.bind(this);
    this.handleCloseCallToAction = this.handleCloseCallToAction.bind(this);
  }

  setOpen(s) {
    this.setState({
      openMenu:s
    });
  }

  toggleDrawer() {
    this.setOpen(!this.state['openMenu']);
  }

  setUserInput(a) {
    console.log("setUserInput: " + a);
    this.setState({user_input:a});
  }

  fetchData(address) {
    console.log("Fetching for address: "+address);
    fetch("https://api.bloomeria.org/nfts/" + address, {mode:'cors'})
      .then(res => res.json())
      .then(
        (result) => {
          this.setState({
            isLoaded: true,
            items: result,
            nftrees: getNFTrees(result)
          });
          if (!hasNFTrees(result)){
            this.setOpenCallToAction(true);
          }
        },
        (error) => {
          this.setState({
            isLoaded: true,
            error
          });
        }
      )
  }

  refreshData() {
    // User changed input, we need to refresh
    if (this.state['user_input'] !== null) {
      // ENS provided as input
      if (this.state['user_input'].includes('.eth')) {
        const user_ens = this.state['user_input'];
        eth_provider.resolveName(this.state['user_input']).then(
          (result) => {
            if (result !== null){
              this.setState({
                user_address:result,
                user_ens:user_ens
              });
              this.fetchData(result);
            }
          }
        );

      // Regular address provided as input
      } else {
        this.setState({
          user_address: this.state['user_input'],
          user_ens: null
        });
        this.fetchData(this.state['user_input']);
        // Try to reverse resolve
        eth_provider.lookupAddress(this.state['user_address']).then(
          (result) => {
            console.log("Got answer from ENS: "+result + " for address: "+this.state['user_address']);
            if (result !== null){
              this.setState({user_ens:result})
            }
          }
        );
      }
      this.setState({user_input: null});
    }
  }

  componentDidUpdate() {
    if (this.state['user_input'] !== null){
      console.log("Refreshing data because user_input is not null");
      this.refreshData();
    }
  }

  componentDidMount() {
    this.setState({user_input:default_address});
    this.refreshData();
  }

  setOpenCallToAction(s) {
    this.setState({
      openCallToActionModal:s
    });
  }

  handleCloseCallToAction(){
    this.setOpenCallToAction(false);
    this.setUserInput(default_address);
  }

  render() {
    return (
      <ThemeProvider theme={mdTheme}>
        <Box sx={{ display: 'flex' }}>
          <CssBaseline />
          <AppBar position="absolute" open={this.state['openMenu']}>
            <Toolbar
              sx={{
                pr: '24px', // keep right padding when drawer closed
              }}
            >
              <IconButton
                edge="start"
                
                aria-label="open drawer"
                // onClick={this.toggleDrawer}
                sx={{
                  marginRight: '36px',
                  ...(this.state['openMenu'] && { display: 'none' }),
                  color: 'white'
                }}
              >
                <MenuIcon />
              </IconButton>
              <Typography
                component="h1"
                variant="h6"
                color="inherit"
                noWrap
                sx={{ flexGrow: 1, color:'white'}}
              >
                Bloomeria's Dashboard
              </Typography>
            </Toolbar>
          </AppBar>

{/*           
          <Drawer variant="permanent" open={this.state['openMenu']}>
            <Toolbar
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                px: [1],
              }}
            >
              <IconButton onClick={this.toggleDrawer}>
                <ChevronLeftIcon />
              </IconButton>
            </Toolbar>
            <Divider />
            <List component="nav">
              {mainListItems}
            </List>
          </Drawer> */}

          <Box
            component="main"
            sx={{
              backgroundColor: (theme) => theme.palette.secondary.main,
              flexGrow: 1,
              height: '100vh',
              overflow: 'auto',
            }}
          >
            <Toolbar />
            <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
              <Grid container spacing={2}>
                
                <Grid item xs={12}>
                  <Paper
                    sx={{
                      p: 2,
                      display: 'flex',
                      flexDirection: 'column'
                    }}
                  >
                    <span style={{textAlign:"center"}}>
                    <Typography variant="h5"  sx={{overflow: 'hidden',textOverflow: 'ellipsis' }}>
                      Welcome to Bloomeria's Web3 dashboard!
                    </Typography>
                    </span>

                    <span style={{padding:"8px"}}>
                      <Typography variant="body1">
                        We are an organization that helps communities safeguard green areas, connects actors, builds a community of contributors and establishes transparent participatory governance.
                      </Typography>
                    </span>
                      
                    <span style={{padding:"8px"}}>
                      <Typography variant="body1" >
                        This dashboard is meant to give you an easy way to visualize the projects and the data embedded in our Digital Certificates, try it out with your address!
                      </Typography>
                    </span>

                     <span style={{padding:"8px"}}>
                      <Typography variant="body1" >
                        
                        <Link href="https://medium.com/@Bloomeria_dao/designing-a-crypto-native-carbon-tokenization-process-a0b0ddd622af" target="_blank" sx={{color:(theme)=>theme.palette.info.main}}>
                        Take a look at our Medium articles to get a better understanding of our Digital Certificates 
                        <OpenInNewIcon style={{fontSize:"18px", marginBottom:"-4px", marginLeft:"4px"}}/>
                      </Link>
                      </Typography>
                    </span>  
                    
                  </Paper>
                </Grid>

                <Grid item xs={12} md={8} lg={8}>
                  <Paper
                    sx={{
                      p: 2,
                      display: 'flex',
                      flexDirection: 'column'
                    }}
                  >
                    <UserOverview 
                      user_address={this.state['user_address']}
                      user_ens={this.state['user_ens']}
                      setUserAddress={this.setUserInput} 
                      nftrees={this.state['nftrees']}
                      has_member_card={hasMemberCard(this.state['items'])}
                      items={this.state['items']}
                      eth_provider={eth_provider}
                    />
                  </Paper>
                </Grid>
                

                <Grid item xs={12} md={4} lg={4}>
                  <Paper
                    sx={{
                      p: 2,
                      display: 'flex',
                      flexDirection: 'column'
                    }}
                  >
                    <Typography variant='h5'>
                      Bloomeria's Collections
                    </Typography>
                    <NFTOverview
                      theme
                      collections={this.state['items']}
                    />
                  </Paper>
                </Grid>

                {/* <Grid item xs={12}>
                  <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
                  <Typography variant="h4">Timeline</Typography>
                    <TimelineComponent></TimelineComponent>
                  </Paper>
                </Grid> */}

                <Grid item xs={12}>
                  <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
                  <Typography variant="h4">Digital Certificates owned</Typography>
                  <NFTreesGallery theme nftrees={this.state['nftrees']} isLoaded={this.state['isLoaded']} user_address={this.state['user_address']} />
                  </Paper>
                </Grid>

                <Grid item xs={12}>
                  <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
                  <Typography variant="h4">Map overview</Typography>
                    <MapOverview theme nftrees={this.state['nftrees']} isLoaded={this.state['isLoaded']} user_address={this.state['user_address']} />
                  </Paper>
                </Grid>

              </Grid>

              <Copyright sx={{ pt: 4 }} />

            </Container>
          </Box>
        </Box>
        <CallToActionModal open={this.state['openCallToActionModal']} onClose={this.handleCloseCallToAction} user_address={this.state['user_address']} user_ens={this.state['user_ens']}/>
      </ThemeProvider>
    );
  }

}

class WidgetContent extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      user_address: default_address,
      user_ens: null,
      user_input: null,
      error: null,
      isLoaded: false,
      items: [],
      nftrees: [],
      openCallToActionModal: false
    };
  }

  render() {
    return (
      <ThemeProvider theme={mdTheme}>
        <Box sx={{ display: 'flex' }}>
          <CssBaseline />
          <Grid item xs={12} md={8} lg={8}>
                  <Paper
                    sx={{
                      p: 2,
                      display: 'flex',
                      flexDirection: 'column'
                    }}
                  >
                    <UserOverview 
                      user_address={this.state['user_address']}
                      user_ens={this.state['user_ens']}
                      setUserAddress={null} 
                      nftrees={this.state['nftrees']}
                      has_member_card={hasMemberCard(this.state['items'])}
                      items={this.state['items']}
                      eth_provider={eth_provider}
                    />
                  </Paper>
                </Grid>
        </Box>
      </ThemeProvider>
    )
  }

}

export default function App() {
  if (window.location.pathname !== '/widget') {
    return <DashboardContent />
  } else {
    return <WidgetContent />
  }

}
